module.exports = __webpack_public_path__ + "static/db-logo-678fb88e7d8f08877d443fd475057bed.png";